export default {
    center: {
        recommendTitle1: 'Hello, welcome to check',
        recommendTitle2: 'File',
        recommendTitle: 'Summary',
        recommendedQuestions: 'Suggestions',
        helpTitle: 'Regarding this document, I can also help you with:',
        loadingTitle: 'Reading file...',
        recommend: 'Hello, welcome to ',
        regenerate: 'Regenerate',
        assistantPlaceholder: 'Enter "/" to wake up the assistant, enter "{\'@\'}" to ask the specified file',
        reference: 'The content is AI generated for reference only',
        knowledgeHeader: 'Powerful AI Chatbot with Knowledge Base',
        knowledgeHeaderTip: 'Leverage LLM to converse with documents for AI-driven knowledge search and easy comprehension  ',
        knowledgeTitle1: 'Accurate document parsing',
        knowledgeTitle1Tip1: 'Paragraph recognition: Able to handle complex layout and spreads for raw data integrity',
        knowledgeTitle1Tip2: 'Complex table recognition: Able to identify merged cells and complex tables for accurate information transmission ',
        knowledgeTitle2: 'Multidimensional Q&A',
        knowledgeTitle2Tip1: 'Recommended questions: Each answer can lead users to a chain of new questions based on the document contents.',
        knowledgeTitle2Tip2: 'Knowledge-base-wide Q&A: Support global semantic retrieval and knowledge-base-wide content summary',
        knowledgeTitle3: 'Credible & Traceable',
        knowledgeTitle3Tip1: 'Hyperlinked references: Each answer comes with references in the form of a hyperlinked page number or URL.',
        knowledgeTitle3Tip2: 'One-click tracing: Redirect to the referenced paragraph in the original text in one click.',
        knowledgeDescLeft: 'Note: Support parsing of PDF, DOC, DOCX, TXT, MarkDown files, which cannot exceed',
        knowledgeDescRight: 'million(s) characters. The capacity expansion feature is coming soon.',
        createKnowledge: 'Create Knowledge Base',
        editKnowledge: 'Edit knowledge base',
        clickUpload: 'Click to upload',
        supportMore: 'Support for uploading one or more files',
        onlySupport: 'Support uploading word/pdf/txt/ppt files only,',
        limit: 'Limit ',
        chatLog: 'Conversation',
        stop: 'Stop generating',
        reopen: 'New chat will be created for more topics',
        hello: 'Hello, I\'m YaYi',
        answer: 'You can ask me one of the following questions:',
        change: 'Click to change',
        promptCheck: 'Prompt View',
        addConversation: 'New Chat',
        copy: 'Copy',
        copySuccess: 'Copy success',
        startConnection: 'Establishing a connection',
        endConnection: 'Closing a connection',
        startRecord: 'Start recording',
        recording: 'Recording',
        textPlaceHolder: 'Ask me anything',
        selectedContent: 'Selected content:',
        unfold: 'Unfold',
        doWhat: 'What do you want to do with this sentence?',
        welcome: 'Welcome to Yayi Platform',
        alreadyCharge: 'The system has recharged your account with',

        welcomeNew: 'Welcome to',
        welcomeTitle: 'YaYi',
        welcomeTitle2: 'Intelligent dialogue platform',
        newUserTip: 'Special gift for new user systems',
        giveCount:'3',
        TipCount: 'million tokens',
        alreadyChargeTip: 'Instantly embark on your journey of AI innovation experience～',


        yuan: 'yuan!',
        fee: 'Description of fees',
        tips: 'Tips',
        token: '1 token is approximately equal to 1.25 characters',
        feeLess: 'If the fee is insufficient, you can go',
        chargeManagement: 'Recharge management',
        goCharge: 'to top-up fees.',
        gotIt: 'I got it',
        knowledgeName: 'Knowledge base name',
        description: 'Description',
        icon: 'Icon',
        knowledgePlaceholder: 'Please enter the name of the knowledge base',
        knowledgeCountLimit: 'Knowledge base names cannot exceed 20 characters',
        createSuccess: 'Create Success',
        editSuccess: 'Edit Success',
        minimize: 'Minimize',
        closeTask: 'Close task',
        total: 'total',
        totalFile: 'files',
        succeeded: 'succeeded',
        fileCount: '',
        failed: 'failed',
        taskRunning: 'Tasks running',
        allTaskSuccess: 'All tasks successful',
        portionTaskFail: 'Partial tasks failure',
        allTaskFail: 'All tasks failed',
        uploadStatus0: 'analyzing',
        uploadStatus1: 'analyzing',
        uploadStatus2: 'upload successful',
        uploadStatus3: 'parse failure',
        uploadStatus4: 'uploading',
        uploadStatus5: 'upload failed',
        uploadStatus6: 'incapacity',
        uploadStatus7: 'parse to null',

        knowledgeTitle4: "Multiple document formats",
        knowledgeList: "Knowledge base list",
        placeholderSelect: 'Please select',
        placeholderKeyword: 'Please enter a name or label for the knowledge base',
        public: "Public",
        publicPrivate: "Internal disclosure",
        private: "Personal",
        update: "update",
        name: 'Name',
        type: "Type",
        fileNumber: "File Count",
        fileSize: "File size",
        updateTime: "Update time",
        words: "words",
        all: "All",
    },
    aside: {
        fileCount: 'files',
        dirCount: 'folders',
        myKnowledge: 'My Knowledge Bases',
        keyword: 'keyword',
        separateKeyword: 'Separate keywords with spaces',
        noData: 'No data available',
        createImmediate: 'Create now',
        word: 'chars',
        upgrade: 'Upgrade',
        deleteFileConfirm: 'Are you sure you want to delete this document? Once deleted, it cannot be recovered',
        deleteFileAllConfirm: 'Are you sure you want to delete this directory and all documents under it? Once deleted, it cannot be recovered',
        deleteAllFileConfirm: 'Are you sure you want to delete all documents under the root directory and its subdirectories? Once deleted, it cannot be recovered',
        addDirectory: 'Add directory',
        uploadFile: 'Upload file',
        edit: 'Edit',
        delete: 'Delete',
        rename: 'Rename',
        moveTo: 'Move to',
        moveHere: 'Move here',
        moveSuccess: 'Move successful',
        deleteKnowledgeConfirm: 'Are you sure you want to delete the current knowledge base?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        deleteKnowledgeLeft: 'After deleting the knowledge base, all files in the knowledge base will be permanently deleted immediately, this operation cannot be undone, please enter the',
        deleteKnowledgeRight: 'to confirm.',
        confirmNamePlaceholder: 'Please enter the knowledge base name to confirm',
        deleteSuccess: 'Delete successfully',
        inconsistentKnowledge: 'Inconsistent knowledge base name',
        uploadImmediate: 'Click here to upload',
        limitless: 'limitless',
        knowledgeCapacity: 'Knowledge base capacity',
        totalCapacity: 'Total capacity of current knowledge base',
        remainCapacity: 'Remaining available',
        deleteDirConfirm: 'Confirm deleting this folder? You can\'t recover it after deletion',
        deleteFileConfirm2: 'Confirm deleting this file?',
        deleteDirTip: 'After deleting a folder, all files in the folder will be deleted synchronously, and this operation cannot be undone.',
        deleteFileTip: 'Unrecoverable after deletion',
        newFolder: 'New Folder',
        onlyAllow: 'Allows import of',
        fileType: 'files only',
        fileSize200M: 'File size exceeds 200M',
        maxFolder: 'You can only create up to 7 levels of directories',
        noResult: 'No result',
        changeKey: 'Try another keyword',
        descUpdateTime: 'descending order of update time',
        ascUpdateTime: 'ascending order of update time',
        descFileSize: 'descending order of file size',
        ascFileSize: 'ascending order of file size',
        nameSort: 'Sort by Name',
        typeSort: 'Sort by type',
        addURL: 'Add URL',
        save: 'Save',
        publicKnowledge:"Public Knowledge Base",
    },
    bottom: {
        serviceAgreement: 'Service Agreement',
        privacyPolicy: 'Privacy Policy'
    }
}